<div
    provideParentForm
    class="system-settings-controller-config-container"
>
    <div class="full-modal-config__form-control-row system-settings-controller-config-container__no-margin-top">
        <div class="full-modal-config__form-control">
            <ng-content select="system-settings-banners-config"></ng-content>
        </div>
    </div>
    <div class="full-modal-config__form-control-row">
        <div class="full-modal-config__form-control">
            <ng-content select="license-quota-config"></ng-content>
        </div> 
    </div>
    <div class="full-modal-config__form-control-row">
        <div class="full-modal-config__form-control">
            <ng-content select="tenancy-mode-config"></ng-content>
        </div>
    </div> 
    <div class="full-modal-config__form-control-row">
        <div class="full-modal-config__form-control">
            <ng-content select="telemetry-config"></ng-content>
        </div>
    </div>
</div>
